// extracted by mini-css-extract-plugin
export default {"element":"TableHead_element__5xPkZ"};